/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 2V6M13 2V4M4 9C4 9 7.5 11 12 11C16.5 11 20 9 20 9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4 5.16808C4 3.4184 5.4184 2 7.16808 2H16.8319C18.5816 2 20 3.4184 20 5.16808V10.5978C20 12.07 19.1682 13.4159 17.8514 14.0743L15.7376 15.1312C14.7048 15.6476 14.1295 16.7773 14.3194 17.9163L14.5068 19.0408C14.765 20.5899 13.5704 22 12 22V22C10.4296 22 9.23502 20.5899 9.4932 19.0408L9.68062 17.9163C9.87046 16.7773 9.29521 15.6476 8.26238 15.1312L6.14857 14.0743C4.83178 13.4159 4 12.07 4 10.5978V5.16808Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M13.6 2H10.4C8.15979 2 7.03969 2 6.18404 2.43597C5.43139 2.81947 4.81947 3.43139 4.43597 4.18404C4 5.03969 4 6.15979 4 8.4V9C4 9 8 11 12 11C16 11 20 9 20 9V8.4C20 6.15979 20 5.03969 19.564 4.18404C19.1805 3.43139 18.5686 2.81947 17.816 2.43597C16.9603 2 15.8402 2 13.6 2Z"
				fill="currentColor"
			/>
			<path
				d="M9.00001 2V6M13 2V4M4 9C4 9 7.5 11 12 11C16.5 11 20 9 20 9M12 22V22C13.5704 22 14.765 20.5899 14.5068 19.0408L14.3194 17.9163C14.1295 16.7773 14.7048 15.6476 15.7376 15.1312L17.8514 14.0743C19.1682 13.4159 20 12.07 20 10.5978V5.16808C20 3.4184 18.5816 2 16.8319 2H7.16808C5.4184 2 4 3.4184 4 5.16808V10.5978C4 12.07 4.83178 13.4159 6.14857 14.0743L8.26238 15.1312C9.29521 15.6476 9.87046 16.7773 9.68062 17.9163L9.4932 19.0408C9.23502 20.5899 10.4296 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M12.0556 1.25C12.1629 1.25 12.25 1.33706 12.25 1.44444V2.25C12.25 2.66421 12.5858 3 13 3C13.4142 3 13.75 2.66421 13.75 2.25V1.44444C13.75 1.33706 13.8371 1.25 13.9444 1.25H14.9485C16.6261 1.25 17.4649 1.25 18.1356 1.49765C19.2325 1.90271 20.0973 2.76747 20.5023 3.8644C20.75 4.53507 20.75 5.37389 20.75 7.05154C20.75 7.5741 20.75 7.83538 20.6813 8.09073C20.5759 8.48223 20.3048 8.8927 19.986 9.14327C19.7782 9.30669 19.5664 9.39707 19.1428 9.57781C18.9677 9.65254 18.7853 9.72809 18.5965 9.80364C16.7622 10.5373 14.3639 11.25 12 11.25C9.6361 11.25 7.2378 10.5373 5.40354 9.80364C5.21467 9.72809 5.03232 9.65254 4.85719 9.57781C4.43362 9.39707 4.22183 9.3067 4.01395 9.14327C3.69521 8.8927 3.42409 8.48223 3.31872 8.09073C3.25 7.83538 3.25 7.5741 3.25 7.05154V5.69444C3.25 5.28172 3.25 5.07536 3.26522 4.90138C3.43441 2.96759 4.96759 1.43441 6.90138 1.26522C7.07536 1.25 7.28172 1.25 7.69444 1.25H7.83333C8.06345 1.25 8.25 1.43655 8.25 1.66667V4.25C8.25 4.66421 8.58579 5 9 5C9.41421 5 9.75 4.66421 9.75 4.25V1.66667C9.75 1.43655 9.93655 1.25 10.1667 1.25H12.0556Z"
				fill="currentColor"
			/>
			<path
				d="M3.68316 10.6997C3.67654 10.6967 3.67323 10.6952 3.67238 10.6948C3.47263 10.6055 3.25136 10.748 3.25001 10.9668C3.25 10.9678 3.25 10.9705 3.25 10.9761C3.25 10.9909 3.25 10.9982 3.25002 11.0051C3.25518 12.5103 4.1049 13.8852 5.44889 14.5629C5.45501 14.566 5.46162 14.5693 5.47484 14.5759L6.96115 15.3191C8.27357 15.9753 9.00068 17.4338 8.75946 18.8812C8.42509 20.8874 9.96613 22.75 12 22.75C14.0339 22.75 15.5749 20.8874 15.2405 18.8812C14.9993 17.4338 15.7264 15.9753 17.0389 15.3191L18.5252 14.5759C18.5384 14.5693 18.545 14.566 18.5511 14.5629C19.8951 13.8852 20.7448 12.5103 20.75 11.0051C20.75 10.9982 20.75 10.9909 20.75 10.9761C20.75 10.9705 20.75 10.9678 20.75 10.9668C20.7486 10.748 20.5274 10.6055 20.3276 10.6948C20.3268 10.6952 20.3235 10.6967 20.3168 10.6997C19.964 10.8599 19.5741 11.0281 19.1535 11.1964C17.2378 11.9627 14.6361 12.75 12 12.75C9.3639 12.75 6.7622 11.9627 4.84646 11.1964C4.42592 11.0281 4.03597 10.8599 3.68316 10.6997Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9 2V6M13 2V4M4 9C4 9 7.5 11 12 11C13.4686 11 14.8307 10.787 15.9993 10.5M12 22V22C13.5704 22 14.765 20.5899 14.5068 19.0408L14.3194 17.9163C14.1295 16.7773 14.7048 15.6476 15.7376 15.1312L17.8514 14.0743C19.1682 13.4159 20 12.07 20 10.5978V5.16808C20 3.4184 18.5816 2 16.8319 2H7.16808C5.4184 2 4 3.4184 4 5.16808V10.5978C4 12.07 4.83178 13.4159 6.14857 14.0743L8.26238 15.1312C9.29521 15.6476 9.87046 16.7773 9.68062 17.9163L9.4932 19.0408C9.23502 20.5899 10.4296 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9.00001 2V6M13 2V4M4 9C4 9 7.5 11 12 11C16.5 11 20 9 20 9M12 22V22C13.5704 22 14.765 20.5899 14.5068 19.0408L14.3194 17.9163C14.1295 16.7773 14.7048 15.6476 15.7376 15.1312L17.8514 14.0743C19.1682 13.4159 20 12.07 20 10.5978V5.16808C20 3.4184 18.5816 2 16.8319 2H7.16808C5.4184 2 4 3.4184 4 5.16808V10.5978C4 12.07 4.83178 13.4159 6.14857 14.0743L8.26238 15.1312C9.29521 15.6476 9.87046 16.7773 9.68062 17.9163L9.4932 19.0408C9.23502 20.5899 10.4296 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M14.35 1.25C16.5902 1.25 17.7103 1.25 18.566 1.68597C19.3186 2.06947 19.9305 2.68139 20.314 3.43404C20.75 4.28969 20.75 5.40979 20.75 7.65V9.8262C20.2224 10.096 19.481 10.4498 18.5965 10.8036C16.7622 11.5373 14.3639 12.25 12 12.25C9.6361 12.25 7.2378 11.5373 5.40354 10.8036C4.51903 10.4498 3.77762 10.096 3.25 9.8262V7.65C3.25 5.40979 3.25 4.28969 3.68597 3.43404C4.06947 2.68139 4.68139 2.06947 5.43404 1.68597C6.28969 1.25 7.40979 1.25 9.65 1.25H14.35Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.75 2V1.25H8.25V2V6C8.25 6.41421 8.58579 6.75 9 6.75C9.41421 6.75 9.75 6.41421 9.75 6V2ZM13.75 2V1.25H12.25V2V4C12.25 4.41421 12.5858 4.75 13 4.75C13.4142 4.75 13.75 4.41421 13.75 4V2ZM3.25 10.4486V9.49829C3.70693 9.71549 4.24546 9.95588 4.84646 10.1963C6.7622 10.9626 9.3639 11.7499 12 11.7499C14.6361 11.7499 17.2378 10.9626 19.1535 10.1963C19.7545 9.95588 20.2931 9.71549 20.75 9.49829V10.4486C20.75 10.9726 20.75 11.2347 20.7205 11.4763C20.5786 12.638 19.935 13.6793 18.9594 14.3257C18.7565 14.4602 18.5222 14.5774 18.0534 14.8117L17.0389 15.319C15.7264 15.9752 14.9993 17.4337 15.2405 18.8811C15.5749 20.8873 14.0339 22.7499 12 22.7499C9.96613 22.7499 8.42509 20.8873 8.75946 18.8811C9.00068 17.4337 8.27357 15.9752 6.96115 15.319L5.9466 14.8117C5.47784 14.5774 5.24347 14.4602 5.04059 14.3257C4.06496 13.6793 3.4214 12.638 3.27951 11.4763C3.25 11.2347 3.25 10.9726 3.25 10.4486Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
